<!-- // header \\ -->
<header class="header-section" *ngIf="daffiliate" [ngClass]="generateHeaderClasses()">
  <div class="comman-width menuFJC">
    <button class="slideToggle" (click)="humbergMenu()" (window:resize)="onResize($event)">
      <img id="slide-icon" src="assets/images/menu.svg" />
    </button>

    <a routerLink="/Home" routerLinkActive="" class="logo" *ngIf="!timiheader && !littleAngleHeader">
      <img src="../assets/images/logo.png" alt="NuLifeSpan Rx" *ngIf="!generateHeaderClasses().includes('dark-header')" />
      <img src="../assets/images/logo-white.png" alt="NuLifeSpan Rx" *ngIf="generateHeaderClasses().includes('dark-header')" />
      </a>
    <a routerLink="/Home" routerLinkActive="" class="logo" *ngIf="littleAngleHeader"><img
        src="../assets/images/lah_logo.png" alt="NuLifeSpan Rx" /></a>
    <div class="timifit-logo" *ngIf="timiheader">
      <a routerLink="/Home">
        <img src="../assets/images/timifit-logo-white.png" alt="Fit Economy" />
      </a>
    </div>

    <nav class="is-hidden-desktop pull-right margin-left" *ngIf="header_full">
      <ul class="">
        <li class="" id="CheckLoginState">
          <i class="search-icon" (click)="inputBoxMobile()"></i>
          <nav-search *ngIf="mobNavSearch"></nav-search>
        </li>
      </ul>
    </nav>

    <nav class="is-hidden-desktop pull-right margin-left" *ngIf="!header_full && isLoggedin" (click)="humbergMenu()">
      <ul class="">
        <li class="">
          <i class="profile-icon"></i>
          <!-- <nav-search *ngIf="mobNavSearch"></nav-search> -->
        </li>
      </ul>
    </nav>

    <nav class="navbar pull-right margin-leftAuto is-hidden-mobile touch">
      <ul class="navbar-nav">
        <li class="nav-item" *ngIf="!header_full">
          <a [routerLink]="['/pet-prescriptions']" (click)="slideToggle()"
            routerLinkActive="active">Pets<span>&nbsp;</span></a>
        </li>
        <li class="nav-item" *ngIf="!header_full">
          <a [routerLink]="['/MyCards']" (click)="slideToggle()" routerLinkActive="active">My
            Cards<span>&nbsp;</span></a>
        </li>
        <li class="nav-item" *ngIf="!header_full" [routerLink]="['/contact']" (click)="slideToggle()" fragment="faqs"
          routerLinkActive="active" class="faqs-icon">
          <a href="/contact/#faqs">Help<span>&nbsp;</span></a>
        </li>
        <!-- little angle menu start-->
        <!-- <li class="nav-item" *ngIf="littleAngleHeader">
                <a [routerLink]="['/MyCards']" routerLinkActive="active">How it works<span>&nbsp;</span></a>
              </li>
              <li class="nav-item" *ngIf="littleAngleHeader">
                <a [routerLink]="['/MyCards']" routerLinkActive="active">Pricing Tool<span>&nbsp;</span></a>
              </li>
              <li class="nav-item" *ngIf="littleAngleHeader">
                <a [routerLink]="['/MyCards']" routerLinkActive="active">About us<span>&nbsp;</span></a>
              </li>
              <li class="nav-item" *ngIf="littleAngleHeader">
                <a [routerLink]="['/MyCards']" routerLinkActive="active">Contact us<span>&nbsp;</span></a>
              </li> -->
        <!-- little angle menu end-->

        <!-- <li class="nav-item" *ngIf="!header_full">
          <a [routerLink]="['/download-app']" (click)="slideToggle()" routerLinkActive="active" class="smart-phone-icon">Download App<span>&nbsp;</span></a>
        </li> -->
        <li class="nav-item menu-hover" *ngIf="!header_full">
          <a class="nav-hover" (click)="slideToggle()">More<span>&nbsp;</span></a>
          <ul>
            <li class="nav-item" *ngIf="!header_full">
              <a [routerLink]="['/Underinsured']" (click)="slideToggle()"
                routerLinkActive="active">Underinsured<span>&nbsp;</span></a>
            </li>
            <li class="nav-item" *ngIf="!header_full">
              <a [routerLink]="['/little-angel-hands']" (click)="slideToggle()" routerLinkActive="active">Little Angel
                Hands<span>&nbsp;</span></a>
            </li>
            <!--<li class="nav-item" *ngIf="!header_full">
              <a [routerLink]="['/fit-economy']" (click)="slideToggle()" routerLinkActive="active">Move to
                Earn<span>&nbsp;</span></a>
            </li>-->
          </ul>
        </li>
        <li class="nav-item" *ngIf="!header_full">
          <a [href]="baseurlbackoffice" target="_blank" class="last signIn">Login</a>
        </li>
        <li class="nav-item" *ngIf="!header_full">
          <a href="javascript:;" (click)="opensignupbox()" class="last signUp">Sign Up</a>
        </li>
        <!--
        <li class="nav-item" *ngIf="!header_full">
          <a [routerLink]="['/contact']" (click)="slideToggle()">Contact Us</a>-->
          <!-- <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')" class="last signIn">Sign In</a> -->
        <!--</li> -->
        <!-- <li class="nav-item">
          <a [routerLink]="['/aboutUs']" (click)="slideToggle()" routerLinkActive="active">About
            Us<span>&nbsp;</span></a>
        </li> -->
        <!-- <li class="nav-item">
          <a [routerLink]="['/pricing']" (click)="slideToggle()"
            routerLinkActive="active">Pricing<span>&nbsp;</span></a>
        </li> -->

        <li class="nav-item" *ngIf="header_full" id="CheckLoginState">
          <nav-search></nav-search>
          <!-- <a [routerLink]="['/contact']" (click)="slideToggle()" routerLinkActive="active">Contact
            Us<span>&nbsp;</span></a> -->
        </li>
        <li class="nav-item" *ngIf="!header_full">
          <!-- <a [routerLink]="['/contact']" (click)="slideToggle()" routerLinkActive="active">Contact
            Us<span>&nbsp;</span></a> -->
        </li>
        <!-- <li class="nav-item download">
          <a [routerLink]="['/download-mobile-app']" (click)="slideToggle()" routerLinkActive="active">Download
            App<span>&nbsp;</span></a>
        </li> -->
      </ul>
    </nav>
    <!--
    <div class="login is-hidden-mobile" *ngIf="!header_full">
      <a href="javascript:;" class="signUp" (click)="slideToggle(); opensignupbox()">Sign In/Sign Up</a>-->
      <!-- <a href="javascript:;" (click)="opensignupbox()" class="last signIn">Sign In</a> -->
    <!--</div>-->

    <!--little angle sing IN start-->
    <!-- <div class="login is-hidden-mobile signInAngle" *ngIf="littleAngleHeader">
      <a class="signUp" [routerLink]="['/contact']" (click)="slideToggle()">Sign In/Sign Up</a>
    </div> -->
    <!--little angle sing IN end-->

    <!-- Logged In header -->
    <div class="header" Id="Search_Header" *ngIf="isLoggedin">
      <div class="headermenu">
        <div class="login_btn TestGroup" style="display: none;">
          <a href="javascript:;" (click)="openlogin_signup($event, 'groupnumber')"></a>
        </div>

        <div class="userArea">
          <i (click)="hidemenubar(); $event.stopPropagation()"></i>
        </div>
        <!-- Dropdown Menu -->
        <div class="menu_main" [hidden]="!menubar">
          <p>General</p>
          <ul>
            <li>
              <i><img src="../assets/images/emailMyCard.svg" /></i>
              {{ sign_in_user_email }}
            </li>
            <li (click)="MySavedCards()">
              <i><img src="/assets/images/mycards.svg" alt="" /></i>
              My Cards
            </li>
          </ul>
          <p>Security</p>
          <ul>
            <li (click)="showchangepass($event)">
              <i><img src="../assets/images/change_pass.svg" alt="" /></i>
              Change Password
            </li>
            <li (click)="MakeSignOut()">
              <i><img src="../assets/images/logout.svg" alt="" /></i>
              Logout
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="login_btn TestGroup" style="display: none;">
      <a href="javascript:;" (click)="openlogin_signup($event, 'groupnumber')"></a>
    </div>
  </div>

  <div class="mobMenu mMenu">
    <nav>
      <div class="m-header-deny" *ngIf="notLoggedin">
        <h2>Save up to 80% on your prescriptions</h2>
        <!-- 
        <div class="login-link">
          <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in'); humbergMenu()">Sign In</a>
          <a href="javascript:;" (click)="opensignupbox(); humbergMenu()">Sign Up</a>
        </div>-->
        <span class="m-close" (click)="humbergMenu()"></span>
      </div>
      <div class="m-header-acess" *ngIf="isLoggedin">
        <span class="name"></span>
        <div class="u-detail">
          <!-- <span>User Name</span> -->
          <span>{{ sign_in_user_email }}</span>
        </div>
        <span class="m-close" (click)="humbergMenu()"></span>
      </div>
      <ul class="m-border">
        <p class="label">GENERAL</p>
        <li>
          <a [routerLink]="['/pet-prescriptions']" (click)="slideToggle()" routerLinkActive="active"
            class="pets-i">Pets</a>
        </li>
        <li>
          <a [routerLink]="['/MyCards']" (click)="slideToggle()" routerLinkActive="active" class="mycards-i">My
            Cards</a>
        </li>
        <li>
          <a [routerLink]="['/contact']" fragment="faqs" (click)="slideToggle()" routerLinkActive="active"
            class="faqs-i faqMobile">Help</a>
        </li>
        <li>
          <a href="javascript:;" class="signUp" (click)="slideToggle(); opensignupbox()">Sign In/Sign Up</a>
        </li>
        <!--
        <li class="more">
          <a (click)="slideToggle()" class="more-i">More</a>
          <ul>
            <li class="nav-item">
              <a [routerLink]="['/Underinsured']" (click)="slideToggle()"
                routerLinkActive="active">Underinsured<span>&nbsp;</span></a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/little-angel-hands']" (click)="slideToggle()" routerLinkActive="active">Little Angel
                Hands<span>&nbsp;</span></a>
            </li>
            <li class="nav-item">
              <a [routerLink]="['/fit-economy']" (click)="slideToggle()" routerLinkActive="active">Move to
                Earn<span>&nbsp;</span></a>
            </li>
          </ul>
        </li>
        <li>
          <a href="javascript:;" class="signUp" (click)="slideToggle(); opensignupbox()">Sign In/Sign Up</a>
        </li>-->
        <li>
          <!-- <li>
            <a [routerLink]="['/download-app']" (click)="slideToggle()" routerLinkActive="active" class="smart-phone-icon">Download App<span>&nbsp;</span></a> -->
          <!-- <li *ngIf="littleAngleHeader">
            <a [routerLink]="['/contact']" fragment="faqs" (click)="slideToggle()" routerLinkActive="active" class="faqs-i">How it works</a>
          </li>
          <li *ngIf="littleAngleHeader">
            <a [routerLink]="['/contact']" fragment="faqs" (click)="slideToggle()" routerLinkActive="active" class="faqs-i">Pricing Tool</a>
          </li>
          <li *ngIf="littleAngleHeader">
            <a [routerLink]="['/contact']" fragment="faqs" (click)="slideToggle()" routerLinkActive="active" class="faqs-i">About us</a>
          </li>
          <li *ngIf="littleAngleHeader">
            <a [routerLink]="['/contact']" fragment="faqs" (click)="slideToggle()" routerLinkActive="active" class="faqs-i">Contact us</a>
          </li>
          
         -->
          <!-- </li> -->
          <!--<li>
          <a [routerLink]="['/fit-economy']" (click)="slideToggle()" routerLinkActive="active" class="dollar-icon">Move to Earn<span>&nbsp;</span></a>
        </li> !-->
          <!-- <div class="login signInAngle" id = "signInAngleBtn" *ngIf="littleAngleHeader">
          <a class="signUp" [routerLink]="['/contact']" (click)="slideToggle();opensignupbox">Sign In/Sign Up</a>
        </div> -->
          <!-- <li>
          <a [routerLink]="['/aboutUs']" (click)="slideToggle()" routerLinkActive="active" class="about-i">About Us</a>
        </li> -->
          <!-- <li>
          <a [routerLink]="['/pricing']" (click)="slideToggle()" routerLinkActive="active">Pricing</a>
        </li> -->
          <!-- <li>
          <a [routerLink]="['/download-mobile-app']" (click)="slideToggle()" routerLinkActive="active"
            class="downapp-i">Download App</a>
        </li> -->
          <!-- <li>
          <a [routerLink]="['/howItWorks']" (click)="slideToggle()" routerLinkActive="active" class="how-i">How It
            Works</a>
        </li> -->
          <!-- <li>
          <a [routerLink]="['/contact']" (click)="slideToggle()" routerLinkActive="active" class="help-i">Help</a>
        </li> -->
          <!-- <li>
          <a href="tel://+1541-754-3010" (click)="slideToggle()" routerLinkActive="active" class="contact-i">+1
            541-754-3010</a>
        </li> -->
      </ul>
      <ul class="m-border" *ngIf="isLoggedin">
        <p class="label">SECURITY</p>
        <!-- <li>
          <a href="javascript:void(0)" class="mycard-p-i" (click)="MySavedCards(); humbergMenu()">My Cards</a>
        </li> -->
        <li>
          <a href="javascript:void(0)" class="change-p-i" (click)="showchangepass($event); humbergMenu()">Change
            Password</a>
        </li>
        <li>
          <a href="javascript:void(0)" class="logout-i" (click)="MakeSignOut(); humbergMenu()">Logout</a>
        </li>
      </ul>
    </nav>
  </div>
</header>
<!-- \\ header // -->

<div *ngFor="let message of messages" class="alert alert-success">
  {{ message.text }}
</div>
<div>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <app-footer *ngIf="daffiliate"></app-footer>
  <!-- <app-homepage></app-homepage> -->
</div>

<!-- Tabs panel -->
<div class="signupbox " *ngIf="showloginbox">
  <div class="close_search_pharmacy_popup" (click)="removesignup($event)"></div>
  <div class="signup_hero"></div>
  <div class="Signup_login">
    <div class="background_area">
      <div class="gradient_bg is-hidden-mobile"></div>
      <img class="auth_logo" src="/assets/images/logo.png" />
      <p>
        Sign up to save upto 80% on Prescriptions!
      </p>
    </div>
    <div class="form_area">
      <nav>
        <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')" [class.active]="signin_fields">Sign In</a>
        <a href="javascript:;" (click)="openlogin_signup($event, 'sign_up')" [class.active]="signup_fields">Sign Up</a>
      </nav>
      <div class="signup_parent" *ngIf="signup_fields">
        <div class="form_sec">
          <!-- <div class="skip_btn" (click)="SkipSignUp()">Skip Sign up</div> -->
          <h2>Sign Up to {{ _AppName }}</h2>
          <div class="field">
            <input type="email" name="email_signup" id="email_signup" placeholder=" " [(ngModel)]="sign_up_email"
              autocomplete="off" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)" />
            <label for="email_signup">Email Address</label>
          </div>
          <span>{{ sign_up_email_error }}</span>
          <div class="field">
            <input type="password" name="password_signup" id="password_signup" [(ngModel)]="sign_up_password"
              minlength="6" maxlength="20" autocomplete="off" placeholder=" " (keyup)="Keyup_ClearField($event)"
              (blur)="OnBlur_CheckPattern($event)" (keypress)="StopWhiteSpace($event)" />
            <label for="password_signup">Password</label>
          </div>
          <span>{{ sign_up_password_error }}</span>
          <div class="field">
            <input type="password" name="c_password_signup" id="c_password_signup" [(ngModel)]="sign_up_cpassword"
              minlength="6" maxlength="20" autocomplete="off" placeholder=" " (keyup)="Keyup_ClearField($event)"
              (blur)="OnBlur_CheckPattern($event)" (keypress)="StopWhiteSpace($event)" />
            <label for="c_password_signup">Confirm Password</label>
          </div>
          <span>{{ sign_up_cpassword_error }}</span>
        </div>
        <div class="signup_btn_sec">
          <div class="btns" (click)="MakeSignUp()">
            Sign Up
          </div>
          <div class="already">
            Already have an account?
            <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')">Sign In here</a>
          </div>
        </div>
        <div class="Login_Signup_Error">{{ sign_up_error }}</div>
        <p class="tncbox">
          By tapping Sign Up below, you confirm that you accept the
          <a [routerLink]="['/termsofuse']" target="_blank">Terms of Use</a>.
        </p>
      </div>

      <div class="signin_parent" *ngIf="signin_fields">
        <div class="form_sec">
          <h2>Sign In to {{ _AppName }}</h2>
          <div class="field">
            <input type="email" name="email_signin" id="email_signin" placeholder=" " [(ngModel)]="sign_in_email"
              autocomplete="off" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)" />
            <label for="email_signin">Email Address</label>
          </div>
          <span>{{ sign_in_email_error }}</span>
          <div class="field">
            <input type="password" name="password_signin" id="password_signin" placeholder=" "
              [(ngModel)]="sign_in_password" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)"
              autocomplete="off" (keypress)="StopWhiteSpace($event)" />
            <label for="password_signin">Password</label>
          </div>
          <span>{{ sign_in_password_error }}</span>
        </div>
        <a href="javascript:;" class="forgot_btn" (click)="ForgotPassword()">Forgot Password</a>
        <div class="signup_btn_sec">
          <div class="btns" (click)="MakeSignIn()">
            Sign In
          </div>
          <div class="already">
            Don’t have account ?
            <a href="javascript:;" (click)="openlogin_signup($event, 'sign_up')">Sign up here</a>
          </div>
        </div>
        <div class="Login_Signup_Error">{{ sign_in_error }}</div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="signupbox groupnumber" *ngIf="groupnumber">
  <div class="Signup_login"> -->
<!-- <div class="close_search_pharmacy_popup" (click)="removeGroupNumber($event)"></div> -->
<!-- <div class="form_area">
      <div class="signup_signin_parent_box">
        <img src="../assets/images/logo-white-bg.png" width="85" height="" alt="hdrx-logo" />
        <h3>Enter Your Details</h3>
        <div class="signup_parent">
          <div class="form_sec">
            <div class="changepassword_main">
              <div class="input_box">
                <div class="field">
                  <input type="text" id="currentFistName" name="currentFullname" placeholder="First Name"
                    [(ngModel)]="current_first_name" autocomplete="off" (keyup)="Keyup_ClearField($event)" required />
                </div>
                <div class="field">
                  <input type="text" id="currentLastName" name="currentFullname" placeholder="Last Name"
                    [(ngModel)]="current_last_name" autocomplete="off" (keyup)="Keyup_ClearField($event)" required />
                </div>

                <div class="field">
                  <input type="text" id="currentEmail" name="currentEmail" placeholder="Email"
                    [(ngModel)]="current_email" autocomplete="off" (keyup)="Keyup_ClearField($event)" required />
                </div>

                <div class="field" *ngIf="group_number">
                  <input type="text" id="currentGroupNumber" name="currentGroupNumber" placeholder="Access Code"
                    [(ngModel)]="current_group_number" autocomplete="off" (keyup)="Keyup_ClearField($event)" required />

                </div>
                <div class="reset_button change_gno_btn access_btn {{accessloader ? 'loader' : ''}}" (click)="setGroupNumber()">
                  {{!accessloader ? 'Enter Access Code' : ''}}
                </div>
              </div>
              

              <div class="Login_Signup_Error" *ngIf="incorrect_fullname">
                Please enter First Name and Last Name
              </div>
              <div class="Login_Signup_Error" *ngIf="incorrect_email">
                Please enter valid Email
              </div>
              <div class="Login_Signup_Error" *ngIf="incorrect_groupnumber">
                Please enter a valid access code
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="success_group_validate" *ngIf="success_group_validate">
  <p>
    Congratulations! Your Access Code is now verified.
  </p>
</div>
<!-- Change Password Box -->
<div class="change_password" *ngIf="changepassword">
  <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="removechangepass($event)"></div>
  <div class="changepassword_main">
    <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="removechangepass($event)"></div>
    <h2>Change Password</h2>
    <div class="input_box">
      <div>
        <input type="password" id="currentpass" name="currentpass" placeholder=" " [(ngModel)]="current_password"
          autocomplete="off" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)"
          (keypress)="StopWhiteSpace($event)" />
        <label for="currentpass">Current Password</label>
        <i (click)="changeIcon('1')" id="status1"></i>
      </div>
      <span>{{ current_password_error }}</span>
      <div>
        <input type="password" id="newpass" name="newpass" placeholder=" " [(ngModel)]="new_password" autocomplete="off"
          (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)" minlength="6" maxlength="20"
          (keypress)="StopWhiteSpace($event)" />
        <label for="newpass">New Password</label>
        <i (click)="changeIcon('2')" id="status2"></i>
      </div>
      <span>{{ new_password_error }}</span>
      <div>
        <input type="password" id="confirmpass" name="confirmpass" placeholder=" " [(ngModel)]="c_new_password"
          minlength="6" maxlength="20" autocomplete="off" (keyup)="Keyup_ClearField($event)"
          (keypress)="StopWhiteSpace($event)" />
        <label for="confirmpass">Confirm New Password</label>
        <i (click)="changeIcon('3')" id="status3"></i>
      </div>
      <span>{{ c_new_password_error }}</span>
      <span style="color:#EE934A">{{ change_password_error }}</span>
      <div class="reset_button change_pwd_btn" (click)="UpdatePassWord()">
        Reset Password
      </div>
    </div>
  </div>
</div>
<!-- success message after change password -->
<div *ngIf="mobsuccess" class="mobsuccess">
  <!-- <div class="mobsuccess"> -->
  <div>
    <img src="../assets/images/mob-success.svg" alt="" />
    <P>Your password has been changed successfuly</P>
    <span (click)="mobCloseToggle()">Go to Sign In</span>
  </div>
</div>
<!-- Forgot Password Box -->
<div class="change_password" *ngIf="forgotpassword_box">
  <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="removeforgot($event)"></div>
  <div class="changepassword_main forgot_pass">
    <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="removeforgot($event)"></div>
    <h2>Forgot Password</h2>
    <div class="input_box">
      <div>
        <input type="email" name="forgotemail" id="forgotemail" placeholder=" " [(ngModel)]="forgot_email"
          autocomplete="off" (click)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)"
          (keyup)="Keyup_ClearField($event)" />
        <label for="forgotemail">Email</label>
        <span style="color:#EE934A">{{ forgot_email_error }}</span>
      </div>
      <div>
        <div *ngIf="otp_sent">
          <input type="text" id="OTP" name="OTP" placeholder=" " [(ngModel)]="input_otp" autocomplete="off"
            (click)="Keyup_ClearField($event)" (keyup)="Keyup_ClearField($event)"
            (blur)="OnBlur_ChangePassword($event)" />
          <label for="OTP">Enter OTP</label>
          <span style="color:#EE934A">{{ input_otp_error }}</span>
        </div>
      </div>

      <div class="reset_button" (click)="Submit_Email_OTP()">Submit</div>
    </div>
  </div>
</div>
<!-------Group Number Box------------>
<div class="change_password" *ngIf="Group_Number_Box">
  <!-- <div class="close_search_pharmacy_popup" (click)="removegroup($event)"></div> -->
  <div class="changepassword_main forgot_pass group_Number__box">
    <div class="skip_btn" (click)="SkipGroupNumber()">Skip Group Number</div>
    <h2>Group Number</h2>
    <div class="input_box">
      <div>
        <span class="staticgroup">PTRX</span><input type="number" id="InputGroup" name="InputGroup" placeholder=" "
          [(ngModel)]="InputGroupNumber" (click)="ClearErrorMessage_InputGroup()" (keyup)="Keyup_ClearField($event)"
          (keypress)="_GrnumberValidate($event)" />
        <label for="currentpass">Group Number</label>
      </div>
      <span>{{ input_groupnumber_error }}</span>
      <div class="reset_button" (click)="SubmitGroupNumber()">Submit</div>
    </div>
  </div>
</div>
<!------------------Reset Password---------------->
<div class="change_password" *ngIf="resetpassword_Box">
  <div class="close_search_pharmacy_popup" (click)="removechangepass($event)"></div>
  <div class="changepassword_main resetpass_box">
    <h2>Reset Password</h2>
    <div class="input_box">
      <div>
        <input type="password" id="resetnewpass" name="resetnewpass" placeholder=" " [(ngModel)]="reset_new_password"
          autocomplete="off" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_ChangePassword($event)" minlength="6"
          maxlength="20" (keypress)="StopWhiteSpace($event)" />
        <label for="newpass">New Password</label>
        <i (click)="changeIcon('4')" id="status4"></i>
      </div>
      <span>{{ reset_new_password_error }}</span>
      <div>
        <input type="password" id="resetconfirmpass" name="resetconfirmpass" placeholder=" " autocomplete="off"
          minlength="6" maxlength="20" [(ngModel)]="reset_c_new_password" (keyup)="Keyup_ClearField($event)"
          (keypress)="StopWhiteSpace($event)" />
        <label for="resetconfirmpass">Confirm New Password</label>
        <i (click)="changeIcon('5')" id="status5"></i>
      </div>
      <span>{{ reset_c_new_password_error }}</span>
      <span style="color:#EE934A">{{ reset_update_password_error }}</span>
      <div class="reset_button" (click)="ResetPassword()">
        Reset
      </div>
    </div>
  </div>
</div>

<!--Search pharmacy popup-->
<div class="top_search">
  <div class="search_pharmacy_popup" *ngIf="ShowDrugdetails">
    <div class="close_search_pharmacy_popup" (click)="CloseDrugDetails()"></div>
    <div class="search_pharmacy_select">
      <h2>{{ SelectedDrug }}</h2>
      <div class="filter_box">
        <div class="lists_box" [ngClass]="{ singleDoseForm: DrugNameTypeSingle }">
          <div (click)="hideme[0] = !hideme[0]; $event.stopPropagation()">
            <label>Type</label>
            <div class="filtertext">
              {{ SelectedDrug }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[0]">
            <ul>
              <li *ngFor="let item of DrugTypeList" (click)="addActive_select($event, 0, item)"
                [ngClass]="{ active: item == Swap_Drug_With_MultiSource }">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box" [ngClass]="{ singleDoseForm: DrugFormSingle }">
          <div (click)="hideme[1] = !hideme[1]; $event.stopPropagation()">
            <label>Form</label>
            <div class="filtertext">
              {{ DrugType }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[1]">
            <ul>
              <li *ngFor="let item of optionlist" (click)="addActive_select($event, 1, item.text)"
                [ngClass]="{ active: item.text == DrugType }">
                {{ item.text }}
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box" [ngClass]="{ singleDoseForm: DrugDoseSingle }">
          <div (click)="hideme[2] = !hideme[2]; $event.stopPropagation()">
            <label>Dosage</label>
            <div class="filtertext">
              {{ DrugDose }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[2]">
            <ul>
              <li *ngFor="let item of DrugDoseList" (click)="addActive_select($event, 2, item)"
                [ngClass]="{ active: item == DrugDose }">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box">
          <div (click)="hideme[3] = !hideme[3]; $event.stopPropagation()">
            <label>Quantity</label>
            <div class="filtertext">
              {{ DrugQuant }}
            </div>
            <i></i>
          </div>
          <div class="lists" [hidden]="!hideme[3]" hidden>
            <ul>
              <li *ngFor="let item of DrugQuantityList" (click)="addActive_select($event, 3, item)"
                [ngClass]="{ active: item.DisplayQuantity === DrugQuant }">
                {{ item }}
              </li>
              <li (click)="addActive_select($event, -3, QuantityManual)">
                Enter a Quantity
              </li>
            </ul>
          </div>
        </div>
        <div class="lists_box PharmacyNear">
          <div>
            <label>Pharmacies Near</label>

            <!-- <div class="filtertext">Oakland, CA 94618, USA</div> -->
            <div class="filtertext">
              <input type="tel" id="getzipcodeTop" placeholder="Type zipcode" value="{{ _CurrLocation }}"
                [(ngModel)]="_UserZip" maxlength="5" (click)="ClearErrorMessage()" (blur)="ClearErrorClass($event)"
                (keyup)="zipCodeLenthInit()" (keypress)="ZipCodeValidate($event)" />
            </div>
            <!-- <i></i> -->
            <span>{{ ZipCodeMessage }}</span>
          </div>
        </div>
        <div class="autopic_location">
          <input type="checkbox" id="pick_location" (change)="GetAutoLocation($event)" />
          <label for="pick_location"><span></span>Auto pick my location</label>
        </div>
        <div class="find_button" (click)="Redirect_LoadPharmacy()">
          Find the Lowest Price
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Enter Quantity Manual Box -->
<div class="change_password ManualQuantity_box" *ngIf="ManualQuantity_box">
  <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="CloseQuantity_Box()"></div>
  <div class="changepassword_main forgot_pass">
    <h2>Enter a quantity</h2>
    <div class="quantity_box_mobile is-hidden-desktop" (click)="CloseQuantity_Box()">
      <img src="/assets/images/closeicon.svg" alt="" height="32" width="32">
    </div>
    <div class="input_box">
      <div>
        <input type="number" id="Quantity_Manual" name="Quantity_Manual" placeholder=" " [(ngModel)]="Quantity_Manual"
          (keypress)="DrugQuantityValidate($event)" />
        <label for="Quantity_Manual">Quantity</label>
      </div>
      <span id="Quant_Error">{{ Quantity_error }}</span>
      <div class="reset_button" (click)="SubmitQuantity()">Submit</div>
    </div>
  </div>
</div>
<!-- <div *ngIf="this.ms.toggle"></div> -->
<!-- <app-getcard *ngIf="daffiliate" id="daffiliate"></app-getcard> -->
<!-- <app-getcard *ngIf="this.ms.toggle"></app-getcard> -->

<!-- main pop-up -->
<div class="main-popup" *ngIf="AffiliatePopUp">
  <div class="popup-inner">
    <span class="close-btn"><img src="../assets/images/closeicon.svg" (click)="Close_Affiliate()" /></span>
    <div class="heading">
      <h3>A Special Message</h3>
      <h2>{{ PopDescText }}</h2>
    </div>

    <div class="coupan-image">
      <img [src]="imagetransform()" />
    </div>
    <button class="start-saving" (click)="Close_Affiliate()">
      START SAVING
    </button>
  </div>
</div>
<!-- main pop-up -->
<div class="signUpModal" *ngIf="signupform">
  <div class="signUpModalContent">
    <!-- step one -->
    <div class="signUpForm" *ngIf="step1signup">
      <img src="../assets/images/logo-white-bg.png" class="signUpLogo">
      <p>Step 1 out of 2</p>
      <h2>Sign Up today & Earn Cash Every Time!</h2>
      <input type="text" (keyup)="clearerror()" [(ngModel)]="fname" name="first_name" id="modalFirstName"
        class="modalSignUpInput" autocomplete="off" placeholder="First Name">
      <input type="text" (keyup)="clearerror()" [(ngModel)]="lname" name="last_name" id="modalLastName"
        class="modalSignUpInput" autocomplete="off" placeholder="Last Name">
      <input type="number" (keyup)="clearerror()" [(ngModel)]="phoneno" name="phone_number" id="modalphoneNumber"
        class="modalSignUpInput" autocomplete="off" placeholder="Phone Number">
      <div class="errorparentbox">
        <input type="email" (keyup)="clearerror()" [(ngModel)]="emailid" name="email" id="modalEmail"
          class="modalSignUpInput" autocomplete="off" placeholder="Email">
        <div class="errorbox" *ngIf="step1error !=''">{{step1error}}</div>
      </div>
      <button type="submit" id="modalSubmit" (click)="submitstep1()" [class.loader]="loaderstart">Save & Continue</button>
    </div>
    <!-- step two -->
    <div class="signUpForm2nd" *ngIf="step2signup">
      <img src="../assets/images/logo-white-bg.png" class="signUpLogo">
      <p>Step 2 out of 2</p>
      <h2>Create Username & Password</h2>
      <input type="text" name="username" id="username" class="modalSignUpInput" autocomplete="off"
        placeholder="Username" [(ngModel)]="username" (keyup)="clearerror()">
      <input type="password" name="password" id="password" class="modalSignUpInput" autocomplete="off"
        placeholder="Password" [(ngModel)]="password" (keyup)="clearerror()">
      <input type="password" name="confirmpassword" id="confirmpassword" class="modalSignUpInput" autocomplete="off"
        placeholder="Confirm Password" [(ngModel)]="confirmpassword" (keyup)="clearerror()">
      <label class="checkboxLabel">
        <input type="checkbox" [(ngModel)]="checkboxconfirm" emptyCheckbox="false" (click)="clearerror()">
        <div></div>
        <span class="">Check this box to agree our <a routerLink="/terms" target="_blank">Terms & Conditions </a> and agree to become a 
          Cashback Rewards Member</span>
      </label>
      <div class="besure">Please be sure to check your spam folder as well!</div>
      <div class="errorbox" *ngIf="ste2error !=''">{{ste2error}}</div>
      <button type="submit" id="modalSubmit" (click)="submitstep2()" [class.loader]="loaderstart">Submit</button>

    </div>

    <!-- Success -->
    <div class="signuparea" *ngIf="signupsucess">
      <img src="../assets/images/logo-white-bg.png" class="signUpLogo">
      <div class="welcome_signup"><img
          src="../assets/images/success-signup.png" />
        <p>You have been registered successfully. Check your email to activate your account.</p>
        <p>Please be sure to check your spam folder as well!</p><a class="btn" [href]="baseurlbackoffice" target="_blank">Sign In Now</a>
      </div>
    </div>
    <div class="Alreadyhave">
      Already have an account?
      <a [href]="baseurlbackoffice" target="_blank">Sign in here</a>
    </div>
    <div class="signUpFormImg">
      <img src="../assets/images/signup.jpg" class="signUpFormRight">
      <img src="../assets/images/signup_cross.png" class="signUpCross" (click)="opensignupbox()">
    </div>
  </div>
</div>
